<ng-container [ngSwitch]="field.type">
    <div class="dff-field-cell" [ngClass]="field.visible ? field.columnSpanClass : ''">
        <span *ngIf="field.visible && templateState" class="template-field-pill"
            [class.template-field-pill--edited]="templateState === 'edited'">
            {{ (templateState === 'edited' ? 'Edited' : 'From template') | translate }}
        </span>
        <mat-form-field
            appearance="outline"
            *ngIf="field.type === FormFieldType.Text && field.visible"
            [class]="field.cssClass"
        >
            <mat-label class="field-label"
                >{{ field.name | translate }}
                <i
                    *ngIf="field.tooltip"
                    class="fa fa-info-circle"
                    aria-hidden="true"
                    [matTooltip]="field.tooltip"
                    matTooltipPosition="right"
                ></i>
            </mat-label>
            <input
                matInput
                [(ngModel)]="entity[field.property]"
                [required]="field.required"
                [disabled]="field.readonly"
                [class.cursor-not-allowed]="field.readonly"
                (change)="field.onChange($event, field)"
                (input)="emitValueChanged()"
                [placeholder]="field.tooltip"
            />
            <mat-error
                >{{ field.name | translate }}
                {{ "is required" | translate }}</mat-error
            >
        </mat-form-field>

        <mat-form-field
            appearance="outline"
            *ngIf="
                field.type === FormFieldType.TextArea && field.visible
            "
        >
            <mat-label class="field-label"
                >{{ field.name | translate }}
                <i
                    *ngIf="field.tooltip"
                    class="fa fa-info-circle"
                    aria-hidden="true"
                    [matTooltip]="field.tooltip"
                    matTooltipPosition="right"
                ></i>
            </mat-label>
            <textarea
                matInput
                [(ngModel)]="entity[field.property]"
                [required]="field.required"
                [placeholder]="field.tooltip"
                [disabled]="field.readonly"
                [class.cursor-not-allowed]="field.readonly"
                (input)="emitValueChanged()"
            ></textarea>
            <mat-error
                >{{ field.name | translate }}
                {{ "is required" | translate }}</mat-error
            >
        </mat-form-field>

        <mat-form-field
            appearance="outline"
            [class]="field.cssClass"
            *ngIf="
                (field.type === FormFieldType.SingleSelection ||
                    field.type === FormFieldType.MultipleSelection ||
                    field.type === FormFieldType.HierarchicalSelection) &&
                field.visible
            "
        >
            <mat-label class="field-label"
                >{{ field.name | translate }}
                <i
                    *ngIf="field.tooltip"
                    class="fa fa-info-circle"
                    aria-hidden="true"
                    [matTooltip]="field.tooltip"
                    matTooltipPosition="right"
                ></i>
            </mat-label>
            <mat-select
                (selectionChange)="field.onChange($event, field); emitValueChanged()"
                [(ngModel)]="entity[field.property]"
                [required]="field.required"
                [disabled]="$safeNavigationMigration(field?.readonly)"
                [class.cursor-not-allowed]="field.readonly"
                [multiple]="isMultiple"
                [panelClass]="
                    field.type === FormFieldType.HierarchicalSelection
                        ? 'hierarchical-select-panel'
                        : field.optionTemplate ||
                            field.optionTemplateFields?.length
                          ? 'multiple-select-panel'
                          : ''
                "
                [placeholder]="field.tooltip"
            >
                <mat-option>
                    <ngx-mat-select-search
                        [(ngModel)]="entity[field.searchProperty]"
                        placeholderLabel="{{ 'Search' | translate }}..."
                        (ngModelChange)="field.onSearchChange($event, field)"
                    >
                    </ngx-mat-select-search>
                </mat-option>

                <mat-option
                    disabled
                    *ngIf="
                        field.type === FormFieldType.HierarchicalSelection &&
                        (
                            field.options
                            | filter
                                : entity[field.searchProperty]
                                : field.searchKeys
                        ).length === 0
                    "
                >
                    {{ "No options found" | translate }}
                </mat-option>

                <ng-container
                    *ngIf="field.type === FormFieldType.HierarchicalSelection"
                >
                    <ng-container
                        *ngTemplateOutlet="
                            renderTree;
                            context: {
                                nodes:
                                    field.options
                                    | filter
                                        : entity[field.searchProperty]
                                        : field.searchKeys,
                                level: 0,
                            }
                        "
                    ></ng-container>
                </ng-container>

                <ng-container
                    *ngIf="field.type !== FormFieldType.HierarchicalSelection"
                >
                    <ng-container
                        *ngIf="
                            field.groups && field.groups.length > 0;
                            else noGroups
                        "
                    >
                        <mat-optgroup
                            *ngFor="let group of field.groups; trackBy: trackByIndex"
                            [label]="group.groupName"
                        >
                            <mat-option
                                *ngFor="
                                    let option of group.items
                                        | filter: entity[field.searchProperty];
                                    trackBy: trackById
                                "
                                [value]="option.id"
                            >
                                {{ option.name | translate }}
                            </mat-option>
                            <mat-option
                                *ngIf="
                                    (
                                        group.items
                                        | filter: entity[field.searchProperty]
                                    ).length === 0
                                "
                                disabled
                            >
                                {{ "No options found" | translate }}
                            </mat-option>
                        </mat-optgroup>
                    </ng-container>
                </ng-container>

                <mat-select-trigger *ngIf="field.selectionTemplate">
                    <span
                        [innerHTML]="field.selectionTemplate(field) | safeHtml"
                    ></span>
                </mat-select-trigger>

                <ng-template #noGroups>
                    <mat-option
                        *ngIf="
                            field.optionTemplate &&
                            !field.optionTemplateFields?.length &&
                            field.options.length
                        "
                        disabled
                        class="static-option-header"
                    >
                        <div
                            class="select-option header"
                            [innerHTML]="
                                field.optionTemplate(field.options[0], true)
                                    | safeHtml
                            "
                        ></div>
                    </mat-option>
                    <mat-option
                        *ngIf="
                            field.optionTemplateFields?.length &&
                            field.options.length
                        "
                        disabled
                        class="static-option-header"
                    >
                        <app-option-row
                            [option]="field.options[0]"
                            [fields]="field.optionTemplateFields"
                            [isHeader]="true"
                            [labelMap]="field.optionTemplateLabelMap"
                            [badgeFields]="field.optionTemplateBadgeFields"
                        >
                        </app-option-row>
                    </mat-option>

                    <ng-container
                        *ngIf="
                            field.type !== FormFieldType.HierarchicalSelection
                        "
                    >
                        <mat-option
                            *ngFor="
                                let option of field.options
                                    | filter
                                        : entity[field.searchProperty]
                                        : field.searchKeys;
                                trackBy: trackById
                            "
                            [value]="option.id"
                        >
                            <ng-container
                                *ngIf="
                                    field.optionTemplate;
                                    else checkNewTemplate
                                "
                            >
                                <div
                                    class="select-option"
                                    [innerHTML]="
                                        field.optionTemplate(option, false) | safeHtml
                                    "
                                ></div>
                            </ng-container>
                            <ng-template #checkNewTemplate>
                                <ng-container
                                    *ngIf="
                                        field.optionTemplateFields?.length;
                                        else defaultOption
                                    "
                                >
                                    <app-option-row
                                        [option]="option"
                                        [fields]="field.optionTemplateFields"
                                        [isHeader]="false"
                                        [labelMap]="
                                            field.optionTemplateLabelMap
                                        "
                                        [badgeFields]="
                                            field.optionTemplateBadgeFields
                                        "
                                    >
                                    </app-option-row>
                                </ng-container>
                            </ng-template>
                            <ng-template #defaultOption>
                                {{ option.name | translate }}
                            </ng-template>
                        </mat-option>
                    </ng-container>

                    <mat-option
                        *ngIf="
                            (
                                field.options
                                | filter
                                    : entity[field.searchProperty]
                                    : field.searchKeys
                            ).length === 0 &&
                            field.type !== FormFieldType.HierarchicalSelection
                        "
                        disabled
                    >
                        {{ "No options found" | translate }}
                    </mat-option>
                </ng-template>

                <ng-template #renderTree let-nodes="nodes" let-level="level">
                    <ng-container *ngFor="let node of nodes; trackBy: trackById">
                        <mat-option
                            [value]="node.id"
                            [ngClass]="'mat-level-' + level"
                        >
                            <ng-container
                                *ngFor="
                                    let i of [].constructor(level);
                                    let idx = index;
                                    trackBy: trackByIndex
                                "
                            >
                                <div
                                    class="pre-option-line"
                                    [ngClass]="'pre-option-level-' + idx"
                                ></div>
                            </ng-container>
                            {{ node.name }}
                        </mat-option>
                        <ng-container
                            *ngIf="node.children && node.children.length > 0"
                        >
                            <ng-container
                                *ngTemplateOutlet="
                                    renderTree;
                                    context: {
                                        nodes: node.children,
                                        level: level + 1,
                                    }
                                "
                            ></ng-container>
                        </ng-container>
                    </ng-container>
                </ng-template>
            </mat-select>

            <button
                class="selection-close-btn"
                *ngIf="
                    entity[field.property] !== null &&
                    entity[field.property] !== undefined &&
                    field.type === FormFieldType.SingleSelection &&
                    !field?.readonly
                "
                mat-icon-button
                matSuffix
                tabindex="-1"
                (click)="clearSelect(field); $event.stopPropagation()"
                aria-label="Clear selection"
            >
                <mat-icon>close</mat-icon>
            </button>

            <button
                *ngIf="field.searchComponent"
                mat-icon-button
                matSuffix
                class="search-suffix-btn"
                tabindex="-1"
                (click)="openSearchDialog(field); $event.stopPropagation()"
                aria-label="Search"
            >
                <mat-icon>search</mat-icon>
            </button>

            <mat-error
                *ngIf="
                    field.required &&
                    (isMultiple
                        ? !entity[field.property]?.length
                        : !entity[field.property])
                "
            >
                {{ field.name | translate }} {{ "is required" | translate }}
            </mat-error>
        </mat-form-field>

        <div
            [class]="field.cssClass + ' padding-y-10'"
            *ngIf="
                field.type === FormFieldType.Checkbox && field.visible
            "
        >
            <mat-checkbox
                color="primary"
                [(ngModel)]="entity[field.property]"
                (change)="field.onChange($event); emitValueChanged()"
            >
                {{ field.name | translate }}
            </mat-checkbox>
        </div>

        <div
            class="padding-y-10"
            *ngIf="
                field.type === FormFieldType.Radio && field.visible
            "
            [class]="field.cssClass"
        >
            <label class="field-label block mb-2"
                >{{ field.name | translate }}
                <i
                    *ngIf="field.tooltip"
                    class="fa fa-info-circle"
                    aria-hidden="true"
                    [matTooltip]="field.tooltip"
                    matTooltipPosition="right"
                ></i>
            </label>
            <mat-radio-group
                [(ngModel)]="entity[field.property]"
                (ngModelChange)="field.onChange($event); emitValueChanged()"
            >
                <mat-radio-button
                    *ngFor="let option of field.options; trackBy: trackByIndex"
                    [value]="option.id"
                >
                    {{ option.name | translate }}
                </mat-radio-button>
            </mat-radio-group>
        </div>

        <div
            class="padding-y-10"
            *ngIf="
                field.type === FormFieldType.Label && field.visible
            "
            [class]="field.cssClass"
            (click)="field.onClick(entity[field.property])"
        >
            <span *ngIf="field.iconClass">
                <i [ngClass]="field.iconClass" class="icon"></i>
            </span>
            <mat-label class="mr-3 field-label"
                >{{ field.name | translate }}
                <i
                    *ngIf="field.tooltip"
                    class="fa fa-info-circle"
                    aria-hidden="true"
                    [matTooltip]="field.tooltip"
                    matTooltipPosition="right"
                ></i>
            </mat-label>
        </div>

        <div
            class="padding-y-10"
            [class]="field.cssClass"
            *ngIf="
                field.type === FormFieldType.Toggle && field.visible
            "
        >
            <mat-label class="mr-3 field-label"
                >{{ field.name | translate }}
                <i
                    *ngIf="field.tooltip"
                    class="fa fa-info-circle"
                    aria-hidden="true"
                    [matTooltip]="field.tooltip"
                    matTooltipPosition="right"
                ></i>
            </mat-label>
            <mat-slide-toggle
                color="primary"
                [disabled]="field.readonly"
                (change)="field.onChange($event, field); emitValueChanged()"
                [(ngModel)]="entity[field.property]"
            ></mat-slide-toggle>
        </div>

        <div
            class="padding-y-10"
            [class]="field.cssClass"
            *ngIf="
                field.type === FormFieldType.Button && field.visible
            "
        >
            <button
                mat-button
                color="primary"
                (click)="field.onClick(entity[field.property])"
                class="button date-name"
                [disabled]="field.readonly"
            >
                <span *ngIf="field.iconClass">
                    <i [ngClass]="field.iconClass" class="icon"></i>
                </span>
                {{ field.name | translate }}
            </button>
        </div>

        <mat-form-field
            appearance="outline"
            *ngIf="
                field.type === FormFieldType.Number && field.visible
            "
        >
            <mat-label class="field-label"
                >{{ field.name | translate }}
                {{ field.additionalLabelText }}
                <i
                    *ngIf="field.tooltip"
                    class="fa fa-info-circle"
                    aria-hidden="true"
                    [matTooltip]="field.tooltip"
                    matTooltipPosition="right"
                ></i>
            </mat-label>
            <input
                matInput
                type="number"
                [required]="field.required"
                [readonly]="field.readonly"
                [placeholder]="field.tooltip"
                [disabled]="field.readonly"
                (input)="field.onChange($event, field)"
                [(ngModel)]="entity[field.property]"
                [min]="field.numericMin"
                [max]="field.numericMax"
                (keypress)="
                    onKeyPressValidateInput($event, field.displayFormat)
                "
            />
            <mat-error
                >{{ field.name | translate }}
                {{ "is required" | translate }}</mat-error
            >
        </mat-form-field>

        <mat-form-field
            appearance="outline"
            *ngIf="field.type === FormFieldType.Time && field.visible"
        >
            <mat-label class="field-label"
                >{{ field.name | translate }}
                <i
                    *ngIf="field.tooltip"
                    class="fa fa-info-circle"
                    aria-hidden="true"
                    [matTooltip]="field.tooltip"
                    matTooltipPosition="right"
                ></i>
            </mat-label>
            <input
                matInput
                [required]="field.required"
                [disabled]="field.readonly"
                class="time-input"
                [(ngModel)]="entity[field.property]"
                (ngModelChange)="onTimeChange($event, field)"
                [ngxMatTimepicker]="timePicker"
                [format]="'' | hour12Flag"
                [readonly]="field.readonly"
                [placeholder]="field.tooltip"
            />
            <ngx-mat-timepicker-toggle
                matSuffix
                [for]="timePicker"
            ></ngx-mat-timepicker-toggle>
            <ngx-mat-timepicker
                #timePicker
                appendToInput="true"
            ></ngx-mat-timepicker>
            <mat-error
                >{{ field.name | translate }}
                {{ "is required" | translate }}</mat-error
            >
        </mat-form-field>

        <div
            class="date-field"
            [ngClass]="field.cssClass"
            *ngIf="field.type === FormFieldType.Date && field.visible"
        >
            <mat-form-field class="row" appearance="outline">
                <mat-label class="field-label"
                    >{{ field.name | translate }}
                    <i
                        *ngIf="field.tooltip"
                        class="fa fa-info-circle"
                        aria-hidden="true"
                        [matTooltip]="field.tooltip"
                        matTooltipPosition="right"
                    ></i>
                </mat-label>
                <input
                    matInput
                    [required]="field.required"
                    [readonly]="field.readonly"
                    [class]="field.cssClass"
                    [(ngModel)]="entity[field.property]"
                    [min]="$safeNavigationMigration(field?.min)"
                    [max]="$safeNavigationMigration(field?.max)"
                    [value]="entity[field.property]"
                    [matDatepicker]="picker"
                    [disabled]="field.readonly"
                    (ngModelChange)="field.onChange($event, field); emitValueChanged()"
                    [placeholder]="field.tooltip"
                />
                <mat-datepicker-toggle
                    matIconSuffix
                    [for]="picker"
                ></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
                <mat-error
                    >{{ field.name | translate }}
                    {{ "is required" | translate }}</mat-error
                >
            </mat-form-field>
        </div>

        <div
            class="container"
            [ngClass]="field.cssClass"
            *ngIf="
                field.type === FormFieldType.DateTime && field.visible
            "
        >
            <mat-form-field appearance="outline" class="row">
                <mat-label class="field-label"
                    >{{ field.name | translate }}
                    <i
                        *ngIf="field.tooltip"
                        class="fa fa-info-circle"
                        aria-hidden="true"
                        [matTooltip]="field.tooltip"
                        matTooltipPosition="right"
                    ></i>
                </mat-label>
                <input
                    matInput
                    [required]="field.required"
                    [class]="field.cssClass"
                    [(ngModel)]="entity[field.property]"
                    [min]="$safeNavigationMigration(field?.min)"
                    [max]="$safeNavigationMigration(field?.max)"
                    [owlDateTimeTrigger]="dtPicker"
                    [owlDateTime]="dtPicker"
                    [disabled]="field.readonly"
                    (ngModelChange)="field.onChange($event, field); emitValueChanged()"
                    [placeholder]="field.tooltip"
                />
                <owl-date-time
                    #dtPicker
                    [panelClass]="'form-owl-date-picker'"
                    [hour12Timer]="('' | hour12Flag) === 12"
                >
                </owl-date-time>
                <mat-error
                    >{{ field.name | translate }}
                    {{ "is required" | translate }}</mat-error
                >
            </mat-form-field>
        </div>

        <div
            class="container"
            [ngClass]="field.cssClass"
            *ngIf="
                field.type === FormFieldType.FileAttachments &&
                field.visible
            "
        >
            <div class="row">
                <a class="add-attachment col-md-6" (click)="field.onClick(0)"
                    >{{ field.additionalLabelText }}
                </a>
                <div
                    *ngFor="let attachment of field.options; trackBy: trackByIndex"
                    class="attachment-item col-md-6"
                >
                    <span
                        >{{ attachment.name }}
                        {{ attachment.description }}</span
                    >
                    <button
                        mat-icon-button
                        color="warn"
                        (click)="field.onClick(attachment.id)"
                    >
                        <mat-icon>close</mat-icon>
                    </button>
                </div>
            </div>
        </div>
    </div>
</ng-container>
